'use strict';

(function () {
  'use strict';

  angular.module('msAssessment').controller('DisclaimerCtrl', DisclaimerCtrl).component('msAssessmentDisclaimer', {
    bindings: {
      programs: '<',
      isComponent: '<',
      providerContext: '<'
    },
    templateUrl: 'assessments/templates/assessmentDisclaimer.html',
    controller: DisclaimerCtrl,
    controllerAs: 'vm'
  });

  DisclaimerCtrl.$inject = ['$rootScope', '$stateParams', 'userSvc', 'providerSvc', 'wellnessSvc', 'assessmentRouter', '$filter', '$log', '$sce', '$timeout', 'domainSvc'];

  function DisclaimerCtrl($rootScope, $stateParams, userSvc, providerSvc, wellnessSvc, assessmentRouter, $filter, $log, $sce, $timeout, domainSvc) {
    var vm = this;
    vm.navigate = _navigate;
    vm.translatePrefix = 'onboarding';
    vm.cobrandingText = '';
    vm.user = [];
    vm.showTelehealth = false;
    vm.logoUrl = '';
    vm.getHelpUrl = '';

    var wellnessCategory = wellnessSvc.getWellnessCategory();
    var $headerHtml = $filter('headerHtml');

    vm.$onInit = _activate;

    function _activate() {
      vm.isComponent = vm.isComponent || false;
      vm.translatePrefix = vm.providerContext && vm.providerContext.translatePrefix ? vm.providerContext.translatePrefix : 'onboarding';

      userSvc.getUser().then(function (resp) {
        vm.user = resp;

        _initBranding(resp);
        _initTelehealth(resp);
      });
      //load the applicable assessments and find the one we are currently taking
      wellnessSvc.getAssessments().then(_findDisclaimer);

      vm.getHelpUrl = domainSvc.getAppDomain() + '/v/help';

      $timeout(function () {
        var disclaimerMain = angular.element('section#assessment-disclaimer-main');
        if (disclaimerMain && disclaimerMain[0]) {
          disclaimerMain[0].focus();
        }
      }, 100);
    }

    function _initTelehealth(user) {
      var isMobileWebView = $rootScope.isMobileWebView === true;
      var userHasTeleheath = user.telehealthProvider !== null && user.assessmentResponseSummaries && user.assessmentResponseSummaries.length > 2;

      if (!userHasTeleheath) {
        return;
      }

      vm.telehealthLogoUrl = user && user.telehealthProvider ? user.telehealthProvider.logoUrl : '';

      // Do not show telehealth in webview due to navigation issues within webview
      vm.showTelehealth = !isMobileWebView;

      // Trigger telehealth post message for webview
      if (isMobileWebView) {
        $rootScope.telehealthTriggered = true;
      }
    }

    function _initBranding(user) {
      vm.cobrandingText = user.organization.name;
      providerSvc.getHeader().then(function (data) {
        var contentItem;
        if (data && data.content) {
          contentItem = data.content.filter(function (headerContent) {
            return headerContent.target === 'image';
          })[0];
          if (contentItem) {
            vm.cobranding = contentItem.replacement;
          }
        }
      });
      // GET HELP CONTENT
      providerSvc.getHeader().then(function (resp) {
        var div = document.createElement('div');
        if (resp.content && angular.isArray(resp.content)) {
          resp.content.push({
            target: 'payerGroupPhonenumber',
            replacement: user.accessCode.phoneNumber
          });
        }

        div.innerHTML = $headerHtml(resp);

        var leftHtml = div.querySelector('.portal-image-bar');
        var rightHtml = div.querySelector('.portal-access-info');

        if (!leftHtml || !rightHtml) {
          $log.debug('GetHelpCtrl: Not using the regular header HTML template.');
          vm.leftSide = $sce.trustAsHtml(div.innerHTML);
        } else {
          $log.debug('GetHelpCtrl: Found the regular header HTML template.');
          vm.leftSide = $sce.trustAsHtml(leftHtml.innerHTML);

          // Regex from here: http://www.regexlib.com/REDetails.aspx?regexp_id=607
          // Modified to allow the UNITED STATES country code of '1' only.
          // Modified to not mutate phone strings ending in " or </a>. Prevents html errors with existing tel links from api
          var rightHtmlWithTelLinks = rightHtml.innerHTML.replace(/1?-?(?:\([2-9]\d{2}\)\ ?|[2-9]\d{2}(?:\-?|\ ?))[2-9]\d{2}[- ]?\d{4}(?!"|<\/a>)/g, '<a href="tel:$&">$&</a>');
          vm.rightSide = $sce.trustAsHtml(rightHtmlWithTelLinks);
        }
      });
    }

    function _findDisclaimer(data) {
      var disclaimer, index;
      if (data[1]) {
        //try to get the matching disclaimer for the wellnessCategory
        for (index in data) {
          if (data.hasOwnProperty(index) && data[index].hasOwnProperty('disclaimers') && data[index].disclaimers[wellnessCategory]) {
            disclaimer = data[index].disclaimers[wellnessCategory];
            break;
          }
        }
      }
      if (disclaimer) {
        vm.disclaimerHtml = disclaimer;
      } else {
        assessmentRouter.goToNextStep($stateParams, {
          name: vm.translatePrefix + '.assessment.overlay'
        });
      }
    }

    function _navigate() {
      assessmentRouter.goToNextStep($stateParams, {
        name: vm.translatePrefix + '.assessment.overlay'
      });
    }
  }
})();